/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ChangeDetectionStrategy, Component, Directive, ViewEncapsulation} from '@angular/core';
import {
  CdkHeaderRow,
  CdkRow,
  CDK_ROW_TEMPLATE,
  CdkRowDef,
  CdkHeaderRowDef,
} from '@angular/cdk/table';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MdHeaderRowDef = CdkHeaderRowDef;
export const /** @type {?} */ _MdCdkRowDef = CdkRowDef;
export const /** @type {?} */ _MdHeaderRow = CdkHeaderRow;
export const /** @type {?} */ _MdRow = CdkRow;
/**
 * Header row definition for the md-table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
export class MdHeaderRowDef extends _MdHeaderRowDef { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdHeaderRowDef]',
  providers: [{provide: CdkHeaderRowDef, useExisting: MdHeaderRowDef}],
  inputs: ['columns: mdHeaderRowDef'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdHeaderRowDef_tsickle_Closure_declarations() {
/** @type {?} */
MdHeaderRowDef.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdHeaderRowDef.ctorParameters;
}

/**
 * Mat-compatible version of MdHeaderRowDef
 */
export class MatHeaderRowDef extends _MdHeaderRowDef { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[matHeaderRowDef]',
  providers: [{provide: CdkHeaderRowDef, useExisting: MatHeaderRowDef}],
  inputs: ['columns: matHeaderRowDef'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MatHeaderRowDef_tsickle_Closure_declarations() {
/** @type {?} */
MatHeaderRowDef.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MatHeaderRowDef.ctorParameters;
}

/**
 * Data row definition for the md-table.
 * Captures the header row's template and other row properties such as the columns to display.
 */
export class MdRowDef extends _MdCdkRowDef { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdRowDef]',
  providers: [{provide: CdkRowDef, useExisting: MdRowDef}],
  inputs: ['columns: mdRowDefColumns'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdRowDef_tsickle_Closure_declarations() {
/** @type {?} */
MdRowDef.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdRowDef.ctorParameters;
}

/**
 * Mat-compatible version of MdRowDef
 */
export class MatRowDef extends _MdCdkRowDef { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[matRowDef]',
  providers: [{provide: CdkRowDef, useExisting: MatRowDef}],
  inputs: ['columns: matRowDefColumns'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MatRowDef_tsickle_Closure_declarations() {
/** @type {?} */
MatRowDef.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MatRowDef.ctorParameters;
}

/**
 * Header template container that contains the cell outlet. Adds the right class and role.
 */
export class MdHeaderRow extends _MdHeaderRow { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-header-row, mat-header-row',
  template: CDK_ROW_TEMPLATE,
  host: {
    'class': 'mat-header-row',
    'role': 'row',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdHeaderRow_tsickle_Closure_declarations() {
/** @type {?} */
MdHeaderRow.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdHeaderRow.ctorParameters;
}

/**
 * Data row template container that contains the cell outlet. Adds the right class and role.
 */
export class MdRow extends _MdRow { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-row, mat-row',
  template: CDK_ROW_TEMPLATE,
  host: {
    'class': 'mat-row',
    'role': 'row',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdRow_tsickle_Closure_declarations() {
/** @type {?} */
MdRow.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdRow.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
